<a
  *ngIf="product"
  class="product-card"
  [ngClass]="{ expanded: expandMode, 'black-friday': isBlackFriday }"
  [routerLink]="['/product', product.id, title]"
  [state]="{ hasNavigated: true, homeIndexData }"
  [class.no-pointer]="disableOverlay"
  (click)="onProduct()"
>
  <div class="product-content">
    <div class="main-container">
      <div class="image-container">
        <img
          class="image-card"
          defaultImage="assets/images/cards/ic_placeholder.png"
          [lazyLoad]="
            product.store_product_logo
              ? product.store_product_logo
              : product.logo
          "
          [alt]="product.store_product_name || product.name"
        />
        <div class="overlay-container" *ngIf="!disableOverlay">
          <p class="hover-title">
            {{ product.store_product_name || product.name }}
          </p>
          <div class="divider"></div>
          <button mat-button class="custom-primary-button">Buy Now</button>
        </div>
      </div>
      <p class="product-name" *ngIf="titleRequired">
        {{ product.store_product_name || product.name }}
      </p>
    </div>

    <div class="discount-badge-container" *ngIf="product.discount > 0">
      <div class="badge-symbol">
        <div class="symbol-line"></div>
        <div class="symbol-circle"></div>
      </div>
      <div class="badge-primary">
        {{ product.discount | convertPrice
        }}<span class="badge-primary-icon">%</span>
      </div>
      <div class="badge-secondary">
        <span class="badge-context">Discount</span>
      </div>
    </div>

    <div class="context-co" *ngIf="expandMode">
      <h4 class="product-title">
        {{ product.store_product_name || product.name }}
      </h4>
      <button
        (click)="$event.stopPropagation()"
        class="category-link"
        mat-stroked-button
        color="primary"
      >
        {{ product.category?.name || 'All' }}
      </button>
    </div>

    <div class="context-co" *ngIf="isBlackFriday">
      <h4 class="product-title">
        {{ product.store_product_name || product.name }}
      </h4>
      <div class="flex-container">
        <button
          (click)="$event.stopPropagation()"
          class="category-link"
          mat-stroked-button
          color="primary"
        >
          {{ product.category?.name || 'All' }}
        </button>
        <img
          class="tag-image"
          src="/assets/images/black-friday-tag.png"
          alt=""
        />
      </div>
    </div>
  </div>
</a>
